import { render, staticRenderFns } from "./productExChangeCode.vue?vue&type=template&id=01f38f85&scoped=true&"
import script from "./productExChangeCode.vue?vue&type=script&lang=js&"
export * from "./productExChangeCode.vue?vue&type=script&lang=js&"
import style0 from "./productExChangeCode.vue?vue&type=style&index=0&id=01f38f85&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f38f85",
  null
  
)

export default component.exports